import { render, staticRenderFns } from "./PriceDisplayer.vue?vue&type=template&id=c0e32522&scoped=true&"
import script from "./PriceDisplayer.vue?vue&type=script&lang=js&"
export * from "./PriceDisplayer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0e32522",
  null
  
)

export default component.exports